module.exports = {
    BASE_URL: 'https://dcfix.dcastalia.com/2305LCG/api/',
    MAP_API_KEY: 'AIzaSyB3nEqKsliw_EQSpaxAq6R8hOUwpGyxJ9s'
}
